import { FC } from "react";
import { cn } from "~/lib/utils";
import { FALLBACK_IMAGE_URL } from "~/utils/constant";
type PropsType = {
  className?: string;
  url: string;
  alt?: string;
};
const ListImage: FC<PropsType> = ({ className, url, alt }) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = FALLBACK_IMAGE_URL;
  };

  return (
    <div className={cn("w-14 h-full aspect-square overflow-hidden rounded", className)}>
      <img
        src={url || FALLBACK_IMAGE_URL}
        alt={alt || "List Image"}
        loading="eager"
        onError={handleImageError}
        className="w-full h-full object-contain rounded-md select-none"
      />
    </div>
  );
};

export default ListImage;
